import gql from 'graphql-tag';

export const coverageHoursOptions = gql`
  query coverageHoursOptions($channelId: UUID!) {
    coverageHoursOptions(channelId: $channelId) {
      categories {
        name
        hasCreatableOptions
      }
      issueTypes {
        category
        issue
        isUsed
      }
    }
  }
`;
